import React, { useContext } from 'react'
import { LoanCalculatorContext } from 'modules/react/loan-calculator/LoanCalculatorContainer'
import LeftContent from 'modules/react/loan-calculator/layout/LeftContent'
import RightContent from 'modules/react/loan-calculator/layout/RightContent'
import CarHeader from 'modules/react/loan-calculator/content/CarHeader'
import InputGroups from 'modules/react/loan-calculator/content/InputGroups'
import SliderGroup from 'modules/react/loan-calculator/content/SliderGroup'
import Notice from 'modules/react/loan-calculator/content/Notice'
import TextItems from 'modules/react/loan-calculator/content/TextItems'
import Title from 'modules/react/loan-calculator/content/Title'
import TotalFooter from 'modules/react/loan-calculator/content/TotalFooter'
import useFormat from 'modules/react/loan-calculator/hooks/useFormat'
import Spinner from 'modules/react/loan-calculator/content/Spinner'
import LoanCalculations from 'modules/react/loan-calculator/content/LoanCalculations'
import DisclaimerText from 'modules/react/loan-calculator/content/DisclaimerText'
import ToggleInterestType from 'modules/react/loan-calculator/content/ToggleInterestType'

export default function Step1() {
  const {
    downPayment,
    setDownPayment,
    loanDurationInMonths,
    setLoanDurationInMonths,
    productDataObject,
    loanCalculationObject,
    isLoadingInitialData,
    modalText
  } = useContext(LoanCalculatorContext)
  const { formatPrice, formatMonthsToYears } = useFormat()
  const { productData, productDataIsLoading } = productDataObject
  const { loanCalculationData, loanCalculationIsLoading } = loanCalculationObject
  const { durationInMonthsRangePrivate } = productData || {}

  return (
    <>
      <LeftContent>
        <CarHeader/>
        {productDataIsLoading || isLoadingInitialData ? (
          <Spinner/>
        ) : (
          <>
            <InputGroups>
              <SliderGroup
                labelLeft='Egenbetaling'
                labelRight={formatPrice(downPayment)}
                postFix=''
                defaultValue={downPayment}
                min={productData?.payoutRange?.min}
                max={productData?.payoutRange?.max}
                onChange={(val) => setDownPayment(val)}
                step={5000}
                totalMarkers={0}
                isPrice
              />
              <SliderGroup
                labelLeft='Lånets løbetid'
                labelRight={formatMonthsToYears(loanDurationInMonths)}
                postFix=' mdr.'
                min={durationInMonthsRangePrivate?.min}
                max={durationInMonthsRangePrivate?.max}
                step={6}
                defaultValue={loanDurationInMonths}
                totalMarkers={durationInMonthsRangePrivate?.max}
                markerSpacing={1}
                onChange={(val) => setLoanDurationInMonths(val)}
              />
              <ToggleInterestType/>
            </InputGroups>
            {!loanCalculationIsLoading || loanCalculationData?.obligationTemplate ? (
              <Notice style={{ marginTop: '40px' }}>
                {loanCalculationData?.obligationTemplate}
              </Notice>
            ) : (
              <div style={{ marginTop: '40px' }}>
                <Spinner/>
              </div>
            )}
          </>
        )}
      </LeftContent>
      <RightContent>
        {modalText?.title && <Title>{modalText?.title}</Title>}
        {productDataIsLoading || isLoadingInitialData ? (
          <TextItems>
            <div style={{ paddingTop: '40px' }}>
              <Spinner/>
            </div>
          </TextItems>
        ) : (
          <>
            <LoanCalculations/>
            <TotalFooter/>
            <DisclaimerText/>
          </>
        )}
      </RightContent>
    </>
  )
}
